const SURVEY_API_URL = process.env.REACT_APP_SURVEY_API_URL || ''

export default {
  SUBMIT: 'CUI_SURVEY_SUBMIT',
  SUBMIT_SUCCESS: 'CUI_SURVEY_SUBMIT_SUCCESS',
  SUBMIT_FAIL: 'CUI_SURVEY_SUBMIT_FAIL',

  API_URL: SURVEY_API_URL,
}
